import React from "react";
import Mapper2 from "../../import_export/import/steps/MatchHeader2";
import Confirm2 from "../../import_export/import/steps/Confirm2";
import StepsManager from "../../import_export/import/StepsManager";
import ImportService from "../../import_export/service/Import";
import UploadFile from "../employee_import/UploadFile";

export default class EmployeeImportManager {

  static async getUploadFileRelativeURL(file) {
    const fileUploadResponse = await ImportService.getUploadFileURL(
      file,
      "IMPORT_PEOPLE_USER"
    );
    return fileUploadResponse.relativePath;
  }

  static async generateAuditLog(file) {
    const filePath = await EmployeeImportManager.getUploadFileRelativeURL(file);
    const columnMapping = await ImportService.getColumnMapping({
      relativeFilePath: filePath,
      module: "PEOPLE_USER",
    });

    return { filePath, columnMapping };
  }

  static getAllCreationSteps(onClickHandler) {
    return [
      {
        title: "Upload File",
        requiredProps: [],
        reqError: "Please upload a file to continue",
        getChild: (props) => (
          <UploadFile
            generateAuditLog={EmployeeImportManager.generateAuditLog}
            fileInfo={props.state.fileInfo}
            setData={props.setData}
            tableName={props.tableName}
          />
        ),
        onClick: (event) => onClickHandler(event, 0),
      },

      {
        title: "Map Columns",
        requiredProps: ["fileContent"],
        reqError: "Please map/skip the unmapped columns to continue",
        getChild: (props) => (
          <Mapper2
            {...props.state}
            setData={props.setData}
            tableName={props.tableName}
            generateNewColumn={StepsManager.createNewColumn}
            setTableColumns={StepsManager.setTableColumns}
            systemHeaders={StepsManager.getColumns(
              props.tableName,
              props.state
            )}
          />
        ),
        onClick: (event) => onClickHandler(event, 1),
      },
      {
        title: "Confirm Import",
        requiredProps: ["mappedHeaders"],
        reqError: "Please check for invalid records",
        getChild: (props) => (
          <Confirm2
            {...props.state}
            setData={props.setData}
            tableName={props.tableName}
            backStepHandler={(e) => onClickHandler(e, 1)}
            confirmationHandler={(e) => onClickHandler(e, 3)}
            segmentValues={StepsManager.getSegmentColumn(
              props.tableName,
              props.state.jobPipelines
            )}
            tableColumns={StepsManager.getColumns(props.tableName, props.state)}
          />
        ),
        onClick: (event) => onClickHandler(event, 2),
      },
    ];
  }
}